// @packages
import React, { useContext, useMemo, useState } from 'react';
import { ISiteState } from '../../utils/types';
import { SiteContextState } from './siteState';

// @constants
const initialState: ISiteState = {
  siteId: 0,
  siteName: ''
};

interface Props {
  children: React.ReactNode;
}

export const SiteProvider = ({ children }: Props) => {
  const [site, setSite] = useState(initialState);

  const handleSelect = (siteInfo: ISiteState) => {
    setSite(siteInfo);
  };

  const handleGoBack = () => {
    setSite({ ...initialState });
  };

  const value = useMemo(
    () => ({
      site,
      onSelect: handleSelect,
      onGoBack: handleGoBack
    }),
    [site]
  );

  return (
    <SiteContextState.Provider value={value}>
      {children}
    </SiteContextState.Provider>
  );
};

// useSiteContext hook
export const useSite = () => useContext(SiteContextState);
